import Color from 'colorjs.io';

/**
 * Darken a hex color by a percentage
 * @param value - hex color
 * @param percent - percentage to darken (0 to 1)
 */
export function darken(value: string, percent: number) {
    const color = new Color(value);
    color.darken(percent);
    return color.toString({ format: 'hex' });
}
